import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, shareReplay, switchMap } from 'rxjs';
import { LanguagesApiService } from './languages-api.service';
import { BotLanguage } from './languages.abstraction';

@Injectable({
  providedIn: 'root',
})
export class LanguagesService {
  #languagesApiService = inject(LanguagesApiService);

  #update$ = new BehaviorSubject<void>(void 0);

  isLoading$ = this.#languagesApiService.isLoading$;

  languagesRes$ = this.#update$.pipe(
    switchMap(() => this.#languagesApiService.getLanguages()),
    shareReplay(1),
  );

  languages$: Observable<BotLanguage[]> = this.languagesRes$.pipe(map(res => res.items));

  refresh(): void {
    this.#update$.next();
  }
}
